import { memo } from 'react'
import AudienceCard from './AudienceCard'
import { CubeLoader } from '@/components/ui/cube-loader'

const AudiencesList = memo(({ isLoading, audiences, selectedIds, onToggleSelection, selectedStages, pixelIsActive }) => {
    if (isLoading) {
        return (
            <div className="tw:flex tw:items-center tw:justify-center tw:h-64">
                <CubeLoader size="default" />
            </div>
        )
    }

    if (!audiences || audiences.length === 0) {
        return (
            <div className="tw:flex tw:flex-col tw:items-center tw:justify-center tw:h-64 tw:text-gray-400">
                <svg className="tw:w-16 tw:h-16 tw:mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={1.5}
                        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
                    />
                </svg>
                <p className="tw:text-lg tw:font-medium tw:mb-1">No audiences found</p>
                <p className="tw:text-sm">Try adjusting your filters or search terms</p>
            </div>
        )
    }

    return (
        <div className="tw:grid tw:grid-cols-[repeat(auto-fill,minmax(264px,1fr))] tw:gap-5 tw:pb-20">
            {audiences.map((audience) => (
                <AudienceCard
                    key={audience.id}
                    audience={audience}
                    isSelected={selectedIds.has(audience.id)}
                    onToggleSelection={onToggleSelection}
                    pixelIsActive={pixelIsActive}
                />
            ))}
        </div>
    )
})

AudiencesList.displayName = 'AudiencesList'

export { AudiencesList }
